import { render } from "./LoadList.vue?vue&type=template&id=e60686ac&scoped=true"
import script from "./LoadList.vue?vue&type=script&lang=js"
export * from "./LoadList.vue?vue&type=script&lang=js"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60686ac"]])

export default __exports__